import axios from 'axios';
import config from '../config/config';

const cleanBaseUrl = () => {
  const url = config.notificationsApiUrl || '';
  if (!url) return '';
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

const sendEmail = async (payload) => {
  const baseUrl = cleanBaseUrl();
  if (!baseUrl) {
    throw new Error('Notifications API nuk është konfiguruar. Vendosni REACT_APP_NOTIFICATIONS_URL.');
  }

  const { data } = await axios.post(`${baseUrl}/notifications/send`, payload);
  return data;
};

const notificationsService = {
  sendEmail,
};

export default notificationsService;
